/**
 * Created by Angelika on 19.09.2017.
 */
import * as actionTypes from '../constants/actionTypes';
import * as def from '../constants/defines';
import * as strings from '../constants/strings';
import StalkerApiManager from '../api/StalkerApiLoaderManager';

let api = StalkerApiManager.getInstance();
let loader = api.getLoader();
let timer = null;

export function getNextEPG(channel) {
    return (dispatch, getState) => {
        const {epg} = getState();
        let [nextDate] = [...epg].find(([k, v]) => !v.loaded);
        dispatch({type: actionTypes.EPG_DAY_REQUEST, date: nextDate});
        return loader.getEPGForDate(channel, nextDate).then(
            data => {
                if (data.length > 0) {
                    dispatch({type: actionTypes.EPG_DAY_SUCCESS, date: nextDate, items: data})
                } else {
                    dispatch({type: actionTypes.EPG_DAY_FAILED, date: nextDate, error: strings.EPG_MISSING})
                }
            },
            error => dispatch({type: actionTypes.EPG_DAY_FAILED, date: nextDate, error: error})
        )
    }
}

export function resetDays() {
    return {type: actionTypes.EPG_RESET_DAYS};
}

export function startUpdate() {
    return dispatch => {
        dispatch({type: actionTypes.EPG_UPDATE_START});
        dispatch(todayUpdate());
    }
}

export function todayUpdate() {
    return dispatch => {
        dispatch({type: actionTypes.EPG_TODAY_UPDATE});
        timer = setTimeout(() => dispatch(todayUpdate()), def.UPDATE_EPG_INTERVAL);
    }
}

export function stopUpdate() {
    clearInterval(timer);
    return ({type: actionTypes.EPG_UPDATE_STOP});
}


// WEBPACK FOOTER //
// ./src/actions/epg.js